import { render, staticRenderFns } from "./fixTopButton.vue?vue&type=template&id=2bb2dca0&scoped=true&"
import script from "./fixTopButton.vue?vue&type=script&lang=js&"
export * from "./fixTopButton.vue?vue&type=script&lang=js&"
import style0 from "./fixTopButton.vue?vue&type=style&index=0&id=2bb2dca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2dca0",
  null
  
)

export default component.exports